import booleans from './booleans'
import datetime from './datetime'
import numbers from './numbers'
import strings from './strings'

export default {
    booleans,
    datetime,
    numbers,
    strings
}
